import { ViewModel, ValidationError } from './OpenedTaskInfo';
import { ProcurementProjectLotDTO, SearchActionResultDTO } from './plyca-dtos-v2';
import { FormGroup, AbstractControl } from '@angular/forms';
import { SearchResultDTO } from './plyca-dtos';
import { Observable } from 'rxjs';
import { FunctionDef } from '../components/forms/form.objects';

export class FEViewModel extends ViewModel {
  public contractNotice: ContractNotice = new ContractNotice();
  public step: number = 0;
  //    public errors: Array<any> = [];
  public loteActivo: number = 0;
  //    public current:string = 'contractNotice.ProcurementProjectLot[loteActivo]';

  getContextStr(): string {
    if (this.contractNotice.fraccionamientoEnLotes) {
      //  this.contractNotice.procurementProjectLot.
      return 'contractNotice.procurementProjectLot[' + this.loteActivo + ']';
    } else {
      return 'contractNotice';
    }
  }

  getContext(): any {
    if (this.contractNotice.fraccionamientoEnLotes) {
      return this.contractNotice.procurementProjectLot[this.loteActivo];
    } else {
      return this.contractNotice;
    }
  }
}

export enum AdaptOperation {
  INSERT = 'INSERT',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE'
}

export class AdaptConfig {
  public operation: AdaptOperation;
  public before: string;
  public after: string;
}

export enum InterfaceDisplayType {
  ACCORDION = 'accordion',
  TAB = 'tab',
  PANEL = 'panel',
  OTHER = ''
}

export enum FormUpdateMode {
  ONCHANGE = 'onChange',
  TIMER = 'timer'
}

export class InterfaceSettings {
  /**
   * Valores posibles: accordion, tab, panel, vacio
   */
  public display: InterfaceDisplayType;
  public descriptionKey: string;
  public showIndex: boolean;
  public fieldGroups: FieldGroup[];
  public actions: FieldAction[];
  public updateMode: FormUpdateMode;
}

/**
 * Interface de descripcion de un componente
 * description: string no internacionalizado o array de string con clave el idioma y valor la descripcion
 * descriptionKey: clave de internacionalizacion a los ficheros es.json, ca.json....
 */
export interface I18nDescribable {
  description: any;
  descriptionKey: string;
  descriptionKeyExpression: string;
}

/**
 * Interface a implementar por las clases que permiten evaluar una expresion en base a funciones y un modelo como argumento
 */
export interface IEvaluableExecutor {
  model: any;
  functions: Array<FunctionDef>;
}


export class FieldGroup implements I18nDescribable {
  public readonly = false;
  public id: string;
  public description: any;
  public descriptionKey: string;
  public descriptionKeyExpression: string;
  public visibility: string;
  // public validationResult: ValidationResultDTO;
  public fieldList: FieldConfig[];
  public fieldSettingsFile: string;
  public displayErrorCount = true;
  public showHeader = true;
  public formGroup: FormGroup;
  public adaptConfig: AdaptConfig;
  public active: boolean;
  public interfaceSettings: InterfaceSettings;
  public styleClass = '';
}

export class SearchConfig {
  // Indica la expansión con la que se realizará el findOne del elemento seleccionado en los resulados de la búsqueda
  public expansion: string;
  /**
   * Indica si se admite o no seleccion múltiple
   */
  public multiSelection: boolean;
  /**
   * Configuración de la acción asociada a la selección de filas del resultado de búsqueda
   */
  public actionCfg: {
    preExcuteFn?: (row: SearchResultDTO[], filters: any) => Observable<any>;
    rowFn: (row: SearchResultDTO) => Observable<SearchActionResultDTO>;
    postExecuteFn?: (row: SearchResultDTO[]) => Observable<any>;
    errorResultExecuteFn?: (err: any) => void;
    okResultExecuteFn?: (result: any) => void;
    /**
     * nombre accion
     */
    //action: string;
    /**
     * Tipo de objeto sobre el que se ejecuta la acción (p.ej: TASK, DOCUMENT, etc). Si no se indica nada se entenderá que es USER
     */
    //objectType?: string;
    /**
     * Lista de nombres de columna devueltos por el buscador cuyos valores serán enviados como parámetros a la acción
     */
    //paramNames?: string[];
    /**
     * Nombre de la columna devuelta por el buscador donde se encuentra el identificador del recurso sobre el que ejecutar la accion
     */
    //idName?: string;
  }
}

/**
 * Configuración de cada campo de un formulario de la aplicacion: formelement
 *
 * textTransformation: expresion javascript que devolvera el texto que se muestra en un campo de tipo SEARCH
 * En el contexto de evaluacion de la expresion se tiene acceso a this que se corresponde al formElement del campo
 */
export class FieldConfig implements I18nDescribable {
  // identificador interno generado al montar el formulario
  public id: string;
  public description: any;
  public descriptionKey: string;
  public descriptionKeyExpression: string;
  // En el caso de SEARCH JSON Path del elemento seleccionado donde se encuentra el dato a mostrar en el campo
  public descriptionProperty: string;
  public descriptionWithID = false;
  public tooltipText: string;
  public helpText: string;
  public helpEntries: string[];
  public visibility: string;
  public condClearFormControl: string;
  public editable: boolean | string;
  public showPerPage: boolean | string;
  public orderByDescription: boolean | string;
  public addEnabled: boolean | string;
  public searchAddEnable = false;
  public jsonField: string;
  public jsonFieldSort: string;
  // Puede estar conectado con un customField
  public customField: string;
  public type: string;
  public typePassword: boolean;
  public subType: string;
  public required: string;
  public maxlength: number;
  public minlength: number;
  public min: number;
  public max: number;
  public maxDecimals: number;
  public prefix: number;
  public suffix: number;
  public fieldStyle: string;
  public widthSize: string;
  public data: any[];
  public links: Link[];
  public pattern: string;
  public tableColumns: Array<FieldConfig>;
  public editorConfig: InterfaceSettings;
  public validations: string | string[];
  public tableAddFunction: string;
  public tableRemoveFunction: string;
  public onChangeRowFunction: string;
  public onImportTableFunction: string;
  public onChangeFunction: string;
  public preEditRowFunction: string;
  public onLostFocus: string;
  public fieldActions: FieldAction[];
  public abstractControl: AbstractControl;
  public value: string;
  public defaultValue: any;
  public dependsOn: string[];
  public idBuscador: string;
  public dropDownDataKey: string;
  public autoSearch: boolean;
  public dataConfig: DataRetrieverConfig;
  public textTransformation: string;
  public columnStyle: any;
  public parameters: any;
  public tabindex: any;
  public autofocus: boolean | string;
  public adaptConfig: AdaptConfig;
  public searchTitle: string;
  public filteringMasterData: boolean;
  public lacyLoad: boolean;
  public searchConfig: SearchConfig;
  public excelLoadEnabled: boolean;
  // atributo para que los componentes de tipo text se puedan visualizar o editar en dialog
  public longText = false;
  // Tags de ayuda para la edición modal del modelo del elemento
  public searchTags = [];
  // ordenacion de tablas
  public order: string;
  // tamaño de página de las tablas
  public pageSize: number;
  public noSortable: boolean;
  // nombre validadores de angular Validator.xxx
  public validators: [string];
  // Path dentro del modelo donde se encuentra un objeto DocumentClassDTO
  // Utilizar para componentes de tipo FILE
  public documentClassJsonPath: string;
  // en el caso de tablas condición que permite habilitar/inhabilitar una fila
  public editableRow: boolean | string;
  public removableRows: boolean | string;
  public rowsAllow = 10;
  public rowActions: FieldAction[];
  public showActionsOnReadOnly: boolean;
  public showGroupedActions: boolean;
  public inputActions: FieldAction[];
  public styleClass = '';
  public dinamicOptionsActive = false;
  public disableExportRow: boolean | string;
  // referencia a grupo al que pertenece
  public fieldGroup: FieldGroup;
  public formId: string;
  public showInfo: boolean;
  public singleFile = true;
  // Dropdown editable option active
  public editableText = false;
  showWait = false;
  // Company
  public editCompanyEnabled: string;
  public addCompanyEnabled: string;
  public searchCompanyEnabled: string;
  public deleteCompanyEnabled: string;
  // Resultado de búsquedas  path .content
  public onSearchFunction: string;
  public actionsAndSearchEnabled = false;
  public showClearOption: boolean | string;

  public filterDivisionType: string;
  public formElement; any;

  constructor() {
    this.editableText = false;
    this.singleFile = true;
    this.typePassword = false;
    this.showActionsOnReadOnly = false;
    this.pageSize = 5;
    this.actionsAndSearchEnabled = false;

    this.editCompanyEnabled = 'true';
    this.addCompanyEnabled = 'true';
    this.searchCompanyEnabled = 'true';
    this.deleteCompanyEnabled = 'true';
  }
}

export class FieldAction {
  functionName: string;
  buttonTextKey: string;
  buttonClass: string;
  imageClass: string;
  enabled: boolean | string;
  visibility: boolean | any;
  showOnReadonly: boolean;

  constructor() {
    this.showOnReadonly = false;

  }

}

/**
 * Configuración para obtener los datos de carga de un combo
 * url: URL del recurso al que se hara un GET
 * labelProperty: Propiedad del DTO que sirve como etiqueta del combo
 * textTransformation: expresion javascript que devolvera el texto que se muestra en cada uno de
 * los elementos del combo. En el contexto de evaluacion de la expresion se tiene acceso a:
 *  this -> Corresponde al formElement del campo
 *  argument[0] -> Corresponde a cada recurso obtenido de la consulta al servidor
 */
export class DataRetrieverConfig {
  url: string;
  jsonPath: string;
  textTransformation: string;
  labelProperty: string;
}

export class Link {
  public rel: string;
  public href: string;
}

export class MasterData {
  public identifier: string;
  public description: string;
  public toString(): string {
    return this.description;
  }
}

export class ValidationErrorUtils {
  static pushError(model: ViewModel, err: ValidationError): void {
    if (!model.errors[err.field]) {
    }
    model.errors[err.field].messages.push(err.message);
  }
}

export class ModelUtils {
  static copyValues(
    cn: ContractNotice,
    property: string,
    origen: number,
    destino: Array<number>
  ) {
    // si existe el lote origen
    if (cn.procurementProjectLot[origen]) {
      let loteOrigen: ProcurementProjectLotDTO = cn.procurementProjectLot[origen];
      // si la propiedad tiene valor en el lote origen
      if (loteOrigen[property]) {
        destino.forEach(i => {
          // si existe el lote destino
          if (cn.procurementProjectLot[i]) {
            cn.procurementProjectLot[i][property] = loteOrigen[property];
          }
        });
      }
    }
  }
}

export class ContractNotice {
  constructor() {
    this.procurementProject = new ProcurementProject();
    this.procurementProjectLot = [];
    this.contractingParty = new ContractingParty();
    this.tenderingProcess = new TenderingProcess();
  }
  // identificador interno
  uuid: string;

  fechaInicio: Date;

  // identificador interno
  propuestaId: string;

  // expedienteId
  contractFolderID: string;

  // identificador de la divisa
  currencyID: string = 'EUR';

  // organo de contratcion
  contractingParty: ContractingParty;

  // informacion sobre el proyecto de compra
  procurementProject: ProcurementProject;

  // indica si hay fraccionamiento en lotes
  fraccionamientoEnLotes: string;

  procurementProjectLot: ProcurementProjectLotDTO[];

  tenderingProcess: TenderingProcess;
}

export class ProcurementProject {
  constructor() {
    this.budget = new BudgetAmount();
    this.tenderingTerms = new TenderingTerms();
  }
  // descripcion corta (titulo)
  name: string;

  // objeto del contrato
  description: string;

  // tipo del expdiente (obras, servicios, suministros)
  typeCode: string;

  // subtipo del expediente (englobar modalidad y categoria)
  subTypeCode: string;

  // presupuesto de licitacion
  budget: BudgetAmount;

  // TODO: CPVS
  _requiredCommodityClassification: string;

  // TODO: material solicitado
  _requestForTenderLine: string;

  // TODO: plazo de ejecucion o entrega
  _plannedPeriod: string;

  // TODO: lugar de entrega
  _realizedLocation: string;

  // condiciones de licitacion
  tenderingTerms: TenderingTerms;
}

export class ContractingParty {
  // nombre del organo de contratacion
  partyName: string;

  // tipo del organo de contratacion
  contractingPartyType: string;

  // cif del organo de contratacion
  partyIdentification: string;
}

export class BudgetAmount {
  // total del presupuesto
  totalAmount: number;

  // importe sin impuestos
  taxExclusiveAmount: number;

  // importe impuestos (no codice)
  taxAmount: number;
}

// export class ProcurementProjectLot {
//   constructor() {
//     this.procurementProject = new ProcurementProject();
//     this.tenderingTerms = new TenderingTerms();
//   }
//   // identificador del lote
//   identifier: string;
//   lotId: number;

//   procurementProject: ProcurementProject;


//   // condiciones de licitacion
//   tenderingTerms: TenderingTerms;
// }

// condiciones de licitacion
export class TenderingTerms {
  constructor() {
    this.pricesRev = 0;
    this.pricesRevMethod = '';
    this.pricesRevNoJust = '';
    this.pricesRevFormula = [];
  }

  // identificador del idioma
  languajeID: string = 'es';

  // normativa aplicable (directiva)
  procurementLegislationDocumentReference: string;

  // TODO
  _tendererQualificationRequest: string;

  // TODO: criterios de adjudicacion;
  _awardingTerms: string;

  // forma de adjudicacion (concurso, subasta...)
  awardingMethodTypeCode: string;

  // TODO: garantias
  _requiredFinancialGuarantee: number;

  // formulas de revision de precios
  _priceRevisionFormulaDescription: string;

  // REVISION DE PRECIOS ////////////////////////////
  pricesRev: number;

  // Metodo
  pricesRevMethod: string;

  // Justificacion No Revisision
  pricesRevNoJust: string;

  // Formulas de Revisión de Precios
  pricesRevFormula: PricesRevFormula[];
}

export class TenderingProcess {
  // procedimiento de contratacion
  procedureCode: string;

  cadenaDePrueba: string;
  booleanDePrueba: boolean;

  // plazo de presentacion de solicitudes de participacion
  _participationRequestReceptionPeriod: string;

  // plazo de presentacion de ofertas
  _tenderSubmissionDeadlinePeriod: string;

  // evento de apertura de ofertas (fechas, tipo, lugar, etc.)
  _openTenderEvent: string;

  // tipo de gasto ordinario o de tramitacion anticipada.
  expenseCode: string;

  // tipo de tramitacion (ordinaria, urgente)
  urgencyCode: string;

  // tipo de presentacion de ofertas (1 electronica, 2 manual)
  submissionMethodCode: string;
}

export class proceduresCode {
  procedureId: string;
  description: string;
  normativeVersion: string;
}

export class PricesRevFormula {
  // Descripcion
  description: string;
}
